<template>
    <div>
        <audio id="musicPlayer" src="music.mp3" volume="0.1" loop autoplay></audio>
    </div>
</template>

<script>
export default {
    name: 'GameBackgroundMusic',
}
</script>
